module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-cc913cf584030a1f5492d60957dd3fb9.png";